import { CookieService } from 'ngx-cookie-service';
import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';
import { COOKIE_NAMES } from '../constants/cookies-names.constant';
import { THEME_COLORS } from '../constants/user-preference.constant';

@Injectable({
    providedIn: 'root'
})

export class CookieStoreService extends CookieService {

    private cookieEncryptSecretKey = "LionO360UI2.0CRM2021";
    private encryptSecretKey = "LionO3602.0CRM2021";

    private getUser() {
        return localStorage.getItem('liono360') ? this.decryptData(localStorage.getItem('liono360'), this.encryptSecretKey) : null;
    }

    encryptData(data: any) {
        const msg = JSON.stringify(data);
        const result = CryptoJS.AES.encrypt(msg, this.cookieEncryptSecretKey).toString();
        return result;
    }

    decryptData(data, key) {
        const decrypted = CryptoJS.AES.decrypt(data, key);
        if (decrypted) {
            try {
                const str = decrypted.toString(CryptoJS.enc.Utf8);
                if (str.length > 0) {
                    return JSON.parse(str);
                } else {
                    return 'error 1';
                }
            } catch (e) {
                return 'error 2';
            }
        }
        return 'error 3';
    }

    setEnCookie(name: string, value: string, options?: {
        expires?: number | Date;
        path?: string;
        domain?: string;
        secure?: boolean;
        sameSite?: 'Lax' | 'None' | 'Strict';
    }) {
        value = this.encryptData(value);
        this.set(name, value, options)
    }

    getEnCookie(name: string) {
        const getValue = this.get(name);
        return getValue ? this.decryptData(getValue, this.cookieEncryptSecretKey) : null;
    }

    setUserEnCookie(name: string, value: any, options?: {
        expires?: number | Date;
        path?: string;
        domain?: string;
        secure?: boolean;
        sameSite?: 'Lax' | 'None' | 'Strict';
    }) {
        name = name + '-' + this.getUser()?.userId;
        value = this.encryptData(value);
        this.set(name, value, options)
    }

    getUserEnCookie(name: string) {
        name = name + '-' + this.getUser()?.userId;
        const getValue = this.get(name);
        return getValue ? this.decryptData(getValue, this.cookieEncryptSecretKey) : null;
    }

    setCookieAcceptance(accepted: boolean) {
        const expiredDate = new Date();
        expiredDate.setDate(expiredDate.getDate() + 365);

        this.setUserEnCookie(COOKIE_NAMES.cookieAcceptance, accepted, { expires: expiredDate });
    }

    isCookieAccepted(): boolean | null {
        const accepted = this.getUserEnCookie(COOKIE_NAMES.cookieAcceptance);
        return accepted;
    }

    setUserPreferenceCookie(userPreference: any) {
        const expiredDate = new Date();
        expiredDate.setDate(expiredDate.getDate() + 60);

        this.setUserEnCookie(COOKIE_NAMES.userPreference, userPreference, { expires: expiredDate });
    }

    getUserPreferanceCookie(): any | null {
        const userPreference = this.getUserEnCookie(COOKIE_NAMES.userPreference);
        return userPreference;
    }

    getThemeColor(){
        const userPreference = this.getUserPreferanceCookie();
        if(userPreference?.theme){
            return THEME_COLORS[userPreference?.theme]||null;
        }

        return null;
    }

    setRememberMeEmailCookie(emailId: any) {
        const expiredDate = new Date();
        expiredDate.setDate(expiredDate.getDate() + 60);

        this.setEnCookie(COOKIE_NAMES.emailId, emailId, { expires: expiredDate });
    }

    setRememberMeUserOrgDetails(userOrgData: { emailId: string, organizationId: string }) {
        const expiredDate = new Date();
        expiredDate.setDate(expiredDate.getDate() + 60);
        // Store the entire object as a JSON string
        this.setEnCookie(COOKIE_NAMES.userOrgData, JSON.stringify(userOrgData), { expires: expiredDate });
      }
      


    getByPaaAuthenCookie(): any | null {
        const userPreference = this.getEnCookie(COOKIE_NAMES.byPassAuthen);
        return userPreference;
    }

    setBypassAuthenticationCookie(dataList: { emailId: string, isRememberKey: any}[]) {
        const expiredDate = new Date();
        expiredDate.setDate(expiredDate.getDate() + 60);
        const encryptedData = this.encryptData(JSON.stringify(dataList));
        this.setEnCookie(COOKIE_NAMES.byPassAuthen, encryptedData,  { expires: expiredDate });
    }

    getDecryptedBypassAuthenticationData(): any[] | null {
        // Retrieve the encrypted cookie value
        const encryptedData = this.getEnCookie(COOKIE_NAMES.byPassAuthen);
        if (encryptedData) {
            const decryptedData = this.decryptData(encryptedData, this.cookieEncryptSecretKey);
            if (decryptedData && decryptedData !== 'error 1' && decryptedData !== 'error 2' && decryptedData !== 'error 3') {
                try {
                    const dataList = JSON.parse(decryptedData);
                    return dataList;
                } catch (e) {
                    return null;
                }
            }
        }
        return null;
    }

    
    deleteRememberMeUserOrgDetails() {
        this.set(COOKIE_NAMES.userOrgData, '', { expires: new Date(0), path: '/' });
    }
    

}
